import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_RESERVATION_SCHEDULES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_RESERVATION_SCHEDULE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_RESERVATION_SCHEDULE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_RESERVATION_SCHEDULE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_RESERVATION_SCHEDULE:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
